export default [
    {
        path: '/master/shipping-type',
        name: 'shipping-type',
        props: true,
        component: () => import('@/views/master/shipping-type/index.vue'),
        meta: {
            pageTitle: 'Shipping Type',
            breadcrumb: [
                {
                text: 'Shipping Type',
                active: true,
                },
            ],
        },
    },
    {
        path: '/master/shipping-type/add',
        name: 'create-shipping-type',
        component: () => import('@/views/master/shipping-type/create.vue'),
        meta: {
            pageTitle: 'Create Shipping Type',
            breadcrumb: [
                {
                text: 'Shipping Type',
                to: { name: 'shipping-type' },
                },
                {
                text: 'Create Shipping Type',
                active: true,
                },
            ],
        },
    },
    {
        path: '/master/shipping-type/:id',
        name: 'detail-shipping-type',
        props: true,
        component: () => import('@/views/master/shipping-type/detail.vue'),
        meta: {
            pageTitle: 'Detail Shipping Type',
            breadcrumb: [
                {
                text: 'Shipping Type',
                to: { name: 'shipping-type' },
                },
                {
                text: 'Detail Shipping Type',
                active: true,
                },
            ],
        },
    },
]